import { twMerge } from '@shared/themes';
import type { ComponentProps } from 'react';

type ContentDetailsPodType = {
  label: string;
  info: string;
};

type ContentDetailsPodProps = ComponentProps<'div'> & ContentDetailsPodType;

function ContentDetailsPod({ className, label, info, ...props }: ContentDetailsPodProps) {
  return (
    <div className={twMerge('bg-container text-foreground py-2 px-4 flex flex-col items-center rounded-md', className)} {...props}>
      <p className="paragraph-s">{label}</p>
      <p className="paragraph-explanatory-strong capitalize">{info}</p>
    </div>
  );
}

export { ContentDetailsPod, type ContentDetailsPodType };
